import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShieldAlt, 
  faFire, 
  faVideo, 
  faDoorClosed,
  faUserShield,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const SicherheitstechnikPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faShieldAlt} />
            </div>
            <h1>Sicherheitstechnik</h1>
            <p>
              Umfassende Sicherheitslösungen zum Schutz von Menschen und Werten
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Fachplanung für Sicherheitstechnik</h2>
            <p>
              Im Bereich Sicherheitstechnik bietet das Ingenieurbüro Neubaur umfassende Planungsleistungen für den 
              Schutz von Menschen, Gebäuden und Werten. Wir planen moderne Sicherheitssysteme, die auf Ihre 
              individuellen Anforderungen zugeschnitten sind.
            </p>
            <p>
              Unsere Planungen berücksichtigen aktuelle Normen, Vorschriften und technische Standards, um ein 
              Höchstmaß an Sicherheit zu gewährleisten. Dabei legen wir besonderen Wert auf die Integration 
              verschiedener Sicherheitssysteme zu einem ganzheitlichen Sicherheitskonzept.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Sicherheitstechnik</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faFire} />
                </div>
                <h3 className="service-feature-title">Brandmeldetechnik</h3>
                <p className="service-feature-text">
                  Planung von Brandmeldeanlagen und Brandschutzsystemen nach aktuellen Normen und Vorschriften.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faBell} />
                </div>
                <h3 className="service-feature-title">Einbruchmeldeanlagen</h3>
                <p className="service-feature-text">
                  Konzeption und Planung von Einbruchmeldeanlagen für verschiedene Sicherheitsstufen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faVideo} />
                </div>
                <h3 className="service-feature-title">Videoüberwachung</h3>
                <p className="service-feature-text">
                  Planung von modernen Videoüberwachungssystemen unter Berücksichtigung datenschutzrechtlicher Vorgaben.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faDoorClosed} />
                </div>
                <h3 className="service-feature-title">Zutrittskontrolle</h3>
                <p className="service-feature-text">
                  Planung von Zutrittskontrollsystemen für die Steuerung und Überwachung von Zugängen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faUserShield} />
                </div>
                <h3 className="service-feature-title">Personensicherheit</h3>
                <p className="service-feature-text">
                  Konzeption von Notrufsystemen und Personenschutzlösungen für gefährdete Bereiche.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <h3 className="service-feature-title">Integrierte Sicherheitskonzepte</h3>
                <p className="service-feature-text">
                  Entwicklung ganzheitlicher Sicherheitskonzepte mit Integration verschiedener Sicherheitssysteme.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Risikoanalyse</h3>
                  <p className="process-text">
                    Wir analysieren potenzielle Risiken und Gefährdungen für Ihr Objekt oder Ihre Einrichtung.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Sicherheitskonzept</h3>
                  <p className="process-text">
                    Basierend auf der Risikoanalyse entwickeln wir ein maßgeschneidertes Sicherheitskonzept.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte technische Planungen für alle sicherheitstechnischen Anlagen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Ausschreibung und Vergabe</h3>
                  <p className="process-text">
                    Wir unterstützen bei der Ausschreibung und Vergabe der Leistungen an qualifizierte Unternehmen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Installationsphase überwachen wir die fachgerechte Umsetzung der Sicherheitssysteme.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Abnahme und Dokumentation</h3>
                  <p className="process-text">
                    Wir begleiten die Abnahme der Systeme und erstellen die erforderliche Dokumentation.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Sicherheit für Ihr Objekt</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich Sicherheitstechnik für Ihr nächstes Projekt. 
              Wir beraten Sie gerne zu maßgeschneiderten Sicherheitslösungen für Ihre individuellen Anforderungen.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SicherheitstechnikPage;
